import * as React from 'react';
// index.js veya App.js içinde en başta olmalı
import './i18n';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import ProductDetail from "./ProductDetail"; // Import ProductDetail component
import ScrollToTopButton from './ScrollToTopButton'; // ScrollToTopButton import
import Footer from "./Footer"; // Footer'ı içe aktar
import NewsDetail from './NewsDetail';
import BlogDetail from './BlogDetail';
import { useTranslation } from 'react-i18next';

import Logo from './Logo';  // yeni bileşeni import et


// Sayfa bileşenleri
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Products from './Products';
import Blog from './Blog';
import News from './News';

const drawerWidth = 300;

function App(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { t, i18n } = useTranslation(); // t ve i18n burada tanımlanmalı

const navItems = [
  { label: t('nav.home'), path: '/', active: true },
  { label: t('nav.about'), path: '/hakkimizda', active: true },
  { label: t('nav.products'), path: '/urunler', active: true },
  { label: t('nav.blog'), path: '/blog', active: true },
  { label: t('nav.news'), path: '/haberler', active: true },
  { label: t('nav.contact'), path: '/iletisim', active: true },
];

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{ my: 2 }}>
  <Logo height={80} />  {/* Drawer için biraz büyük */}
</Box>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              sx={{
                textAlign: 'center',
                pointerEvents: item.active ? 'auto' : 'none',
                opacity: item.active ? 1 : 0.5,
              }}
              component={Link}
              to={item.active ? item.path : '#'}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {/* Dil Seçimi Butonları - Mobil */}
<Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 1 }}>
  {["tr", "en"].map((lang) => (
    <Button
      key={lang}
      onClick={() => i18n.changeLanguage(lang)}
      sx={{
        fontSize: "14px",
        color: i18n.language === lang ? "#fff" : "#000",
        backgroundColor: i18n.language === lang ? "#0077b6" : "#e0e0e0",
        borderRadius: "20px",
        padding: "6px 16px",
        textTransform: "none",
        "&:hover": {
          backgroundColor: i18n.language === lang ? "#005f8e" : "#d5d5d5",
        },
      }}
    >
      {lang === "tr" ? "Türkçe" : "English"}
    </Button>
  ))}
</Box>
     
    </Box>
  );

  const container = window ? () => window.document.body : undefined;

  return (
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CssBaseline />
        <AppBar component="nav" sx={{ backgroundColor: '#ffffff', boxShadow: 'none', minHeight: '30px' }}>
  <Toolbar sx={{ minHeight: '30px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>


            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: 'none' }, color: '#000' }}
            >
              <MenuIcon sx={{ fontSize: 40 }} /> 
            </IconButton>
            <Box
  sx={{
    flexGrow: 1,
    display: 'flex',
    justifyContent: { xs: 'center', sm: 'flex-start' },
  }}
>
  <Logo height={60} />  {/* AppBar için standart */}
</Box>
            <Box sx={{ display: { xs: 'none', sm: 'flex' }, justifyContent: 'center', gap: 5, flexGrow: 1 }}>
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  sx={{
                    color: '#000',
                    fontWeight: 600,
                    fontSize: '14px',
                    pointerEvents: item.active ? 'auto' : 'none',
                    opacity: item.active ? 1 : 0.5,
                  }}
                  component={Link}
                  to={item.active ? item.path : '#'}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'flex' }, justifyContent: 'center', gap: 2 }}>
  {["tr", "en"].map((lang) => (
    <Button
      key={lang}
      onClick={() => i18n.changeLanguage(lang)}
      sx={{
        fontSize: "12px",
        color: i18n.language === lang ? "#fff" : "#000",
        backgroundColor: i18n.language === lang ? "#0077b6" : "#e0e0e0",
        borderRadius: "20px",
        padding: "6px 16px",
        textTransform: "none",
        "&:hover": {
          backgroundColor: i18n.language === lang ? "#005f8e" : "#d5d5d5",
        },
      }}
    >
      {lang.toUpperCase()}
    </Button>
  ))}
</Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, padding: 2 },
            }}
          >
            {drawer}
          </Drawer>
         

        </nav>

        <Box component="main" sx={{ p: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, width: '100%' }}>
          <Toolbar />

          {/* Sayfa yönlendirmeleri */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/urunler" element={<Products />} />
          
        <Route path="/urunler/:id" element={<ProductDetail />} /> {/* Product detail page route */}
      
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/haberler" element={<News />} />
        <Route path="/haberler/:id" element={<NewsDetail />} />
            {/* Bilinmeyen sayfalar için ana sayfaya yönlendir */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
         <ScrollToTopButton /> {/* Scroll to top button component */}
        </Box>
        <Footer />
      </Box>
    </Router>
  );
}

App.propTypes = {
  window: PropTypes.func,
};

export default App;
